export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4659.4413494f.jpg";